module.exports = __webpack_public_path__ + "static/img/gec_fwh.79d0ce6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gecFooter/img/gec_fwh.jpg
// module id = PsHa
// module chunks = 1